module.exports = __webpack_public_path__ + "static/nav-contact-3-303ae952a40e5aca6ff2a8c20cf38c60.jpg";